export default "__VITE_ASSET__DpOdBpX0__"